// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { svgIconClasses } from '@mui/material/SvgIcon';
import { toggleButtonClasses } from '@mui/material/ToggleButton';
import { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup';
import { rem } from '../../tokens/conversions';
import { toggleButtonColors } from './toggleButtonColors';
export var adsToggleButtonVariantClasses = {
    contained: 'AdsToggleButton-contained',
    iconOnly: 'AdsToggleButton-iconOnly',
    text: 'AdsToggleButton-text'
};
export var ToggleButton = function(mode) {
    var c = toggleButtonColors(mode);
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
    var override = {
        MuiToggleButton: {
            defaultProps: {
                disableTouchRipple: true
            },
            styleOverrides: {
                root: (_obj2 = {
                    borderRadius: rem(8),
                    borderColor: c.outlined.default.border,
                    padding: "".concat(rem(8), " ").concat(rem(12)),
                    minHeight: rem(36),
                    minWidth: rem(36),
                    color: c.outlined.default.text,
                    fontWeight: 500,
                    fontSize: rem(14),
                    lineHeight: rem(18),
                    textTransform: 'none',
                    gap: rem(8)
                }, _define_property(_obj2, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(20)
                }), _define_property(_obj2, "&:not(.".concat(toggleButtonClasses.selected, "):hover"), {
                    backgroundColor: c.outlined.default.hover.background
                }), _define_property(_obj2, "&.".concat(toggleButtonClasses.selected), {
                    backgroundColor: c.outlined.selected.background,
                    color: c.outlined.selected.text,
                    borderColor: c.outlined.selected.border
                }), _define_property(_obj2, "&&&.".concat(toggleButtonClasses.disabled), {
                    color: c.outlined.disabled.text,
                    borderColor: c.outlined.disabled.border
                }), _define_property(_obj2, "&&&.".concat(toggleButtonClasses.disabled, ".").concat(toggleButtonClasses.selected), {
                    backgroundColor: c.outlined.selectedDisabled.background,
                    color: c.outlined.selectedDisabled.text,
                    borderColor: c.outlined.selectedDisabled.border
                }), _define_property(_obj2, "&.".concat(adsToggleButtonVariantClasses.contained), (_obj = {
                    backgroundColor: c.contained.default.background,
                    color: c.contained.default.text,
                    borderColor: 'transparent'
                }, _define_property(_obj, "&:not(.".concat(toggleButtonClasses.selected, "):hover"), {
                    backgroundColor: c.contained.default.hover.background
                }), _define_property(_obj, "&.".concat(toggleButtonClasses.selected), {
                    backgroundColor: c.contained.selected.background,
                    color: c.contained.selected.text,
                    borderColor: 'transparent'
                }), _define_property(_obj, "&&&.".concat(toggleButtonClasses.disabled), {
                    backgroundColor: c.contained.disabled.background,
                    color: c.contained.disabled.text,
                    borderColor: 'transparent'
                }), _define_property(_obj, "&&&.".concat(toggleButtonClasses.disabled, ".").concat(toggleButtonClasses.selected), {
                    backgroundColor: c.contained.selectedDisabled.background,
                    color: c.contained.selectedDisabled.text
                }), _obj)), _define_property(_obj2, "&.".concat(adsToggleButtonVariantClasses.iconOnly), {
                    padding: rem(8),
                    gap: 0
                }), _define_property(_obj2, "&.".concat(adsToggleButtonVariantClasses.text), (_obj1 = {
                    borderColor: 'transparent',
                    color: c.text.default.text
                }, _define_property(_obj1, "&:not(.".concat(toggleButtonClasses.selected, "):hover"), {
                    backgroundColor: c.text.default.hover.background
                }), _define_property(_obj1, "&.".concat(toggleButtonClasses.selected), {
                    backgroundColor: c.text.selected.background,
                    color: c.text.selected.text,
                    borderColor: 'transparent'
                }), _define_property(_obj1, "&&&.".concat(toggleButtonClasses.disabled), {
                    color: c.text.disabled.text,
                    borderColor: 'transparent'
                }), _define_property(_obj1, "&&&.".concat(toggleButtonClasses.disabled, ".").concat(toggleButtonClasses.selected), {
                    backgroundColor: c.text.selectedDisabled.background,
                    color: c.text.selectedDisabled.text
                }), _obj1)), _obj2),
                sizeSmall: (_obj3 = {
                    padding: "".concat(rem(4), " ").concat(rem(8)),
                    minHeight: rem(28),
                    minWidth: rem(28),
                    fontSize: rem(12),
                    lineHeight: rem(16),
                    gap: rem(8)
                }, _define_property(_obj3, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(16)
                }), _define_property(_obj3, "&.".concat(adsToggleButtonVariantClasses.iconOnly), {
                    padding: rem(4),
                    gap: 0
                }), _obj3),
                sizeLarge: (_obj4 = {
                    padding: "".concat(rem(12), " ").concat(rem(24)),
                    minHeight: rem(48),
                    minWidth: rem(48),
                    fontSize: rem(16),
                    lineHeight: rem(22),
                    gap: rem(12)
                }, _define_property(_obj4, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(24)
                }), _define_property(_obj4, "&.".concat(adsToggleButtonVariantClasses.iconOnly), {
                    padding: rem(12),
                    gap: 0
                }), _obj4)
            }
        },
        MuiToggleButtonGroup: {
            styleOverrides: {
                root: _define_property({}, "&&& .".concat(toggleButtonGroupClasses.grouped), {
                    '&:not(:first-of-type)': (_obj5 = {}, _define_property(_obj5, "&.".concat(toggleButtonClasses.selected), {
                        borderLeftColor: c.outlined.selected.border
                    }), _define_property(_obj5, "&.".concat(toggleButtonClasses.selected, ".").concat(toggleButtonClasses.disabled), {
                        borderLeftColor: c.outlined.selectedDisabled.border
                    }), _define_property(_obj5, "&.".concat(adsToggleButtonVariantClasses.contained, ".").concat(toggleButtonClasses.selected), {
                        borderLeftColor: 'transparent'
                    }), _define_property(_obj5, "&.".concat(adsToggleButtonVariantClasses.text, ".").concat(toggleButtonClasses.selected), {
                        borderLeftColor: 'transparent'
                    }), _obj5)
                })
            }
        }
    };
    return override;
};

//# sourceMappingURL=ToggleButton.js.map